import { gql } from "urql";
export const GetOrganizationSettingsQuery = gql `
    query GetOrganizationSettings {
        organizations {
            organization {
                organizationId
                settings {
                    intakeForm {
                        isActive
                        url
                    }
                }
            }
        }
        emailSettings {
            emailSettings {
                emailSettingId
                toUsers {
                    userId
                    name
                    imageUrl
                    email
                }
                emailSettingType
                isEnabled
            }
        }
    }
`;
